<!-- VERSÃO MOBILE - Experiência Premium com Glassmorphism -->
<div class="lg:hidden min-h-screen-safe relative flex flex-col">
  <!-- Imagem de fundo fullscreen -->
  <div 
    class="absolute inset-0 bg-cover bg-center bg-no-repeat"
    style="background-image: url('assets/img/LandingPage-1.png');"
  ></div>
  
  <!-- Conteúdo Mobile -->
  <div class="relative z-10 flex-1 flex flex-col justify-center items-center px-6 py-12">
    
    <!-- Logo Grande -->
    <div class="mb-8">
      <img 
        src="assets/icons/Westhetics_White_Full_Logo.svg" 
        alt="Westhetics" 
        class="h-12 w-auto cursor-pointer"
        (click)="goHome()"
      />
    </div>

    <!-- Card Glassmorphism -->
    <div class="w-full max-w-sm bg-white/10 backdrop-blur-xl rounded-2xl border border-white/20 p-6 shadow-2xl text-center">
      
      <!-- Ícone de Erro -->
      <div class="mb-5">
        <div class="w-16 h-16 mx-auto rounded-full bg-red-500/20 backdrop-blur-sm flex items-center justify-center">
          <svg class="w-8 h-8 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clip-rule="evenodd" />
          </svg>
        </div>
      </div>

      <!-- Título -->
      <h1 class="text-2xl font-bold text-white mb-3">
        Link Inválido
      </h1>
      
      <p class="text-white/70 text-sm mb-5">
        O link que você está tentando acessar está incorreto ou foi digitado errado.
      </p>

      <!-- Dicas -->
      <div class="bg-white/10 backdrop-blur-sm rounded-xl p-4 mb-6 text-left border border-white/10">
        <p class="text-sm text-white/90 font-medium mb-2">O que fazer?</p>
        <ul class="text-xs text-white/70 space-y-1.5">
          <li class="flex items-start gap-2">
            <span class="text-white/50">•</span>
            <span>Verifique se o link está correto e completo</span>
          </li>
          <li class="flex items-start gap-2">
            <span class="text-white/50">•</span>
            <span>Copie novamente o link original enviado pela clínica</span>
          </li>
          <li class="flex items-start gap-2">
            <span class="text-white/50">•</span>
            <span>Entre em contato com a clínica para confirmar o link</span>
          </li>
        </ul>
      </div>

      <!-- Botão -->
      <button 
        (click)="goHome()"
        class="w-full py-3.5 px-4 rounded-xl font-semibold transition-all duration-300 flex items-center justify-center gap-2
               bg-white text-westetics-purple-500 hover:bg-white/90 
               focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-transparent
               shadow-lg hover:shadow-xl transform hover:scale-[1.02] active:scale-[0.98]"
      >
        <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
        </svg>
        Voltar para o Início
      </button>
    </div>
  </div>
</div>

<!-- VERSÃO DESKTOP -->
<div class="hidden lg:flex min-h-screen flex-row">
  <!-- Lado Esquerdo - Conteúdo -->
  <div class="flex-1 flex flex-col justify-center items-center bg-[#efeee9]">
    <div class="w-full max-w-lg text-center">
      
      <!-- Logo -->
      <div class="mb-8">
        <img 
          src="assets/icons/logo-v2.svg" 
          alt="Westhetics" 
          class="h-12 w-auto mx-auto cursor-pointer"
          (click)="goHome()"
        />
      </div>

      <!-- Ícone de Erro -->
      <div class="mb-6">
        <div class="w-20 h-20 mx-auto rounded-full bg-red-100 flex items-center justify-center">
          <svg class="w-10 h-10 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clip-rule="evenodd" />
          </svg>
        </div>
      </div>

      <!-- Título -->
      <h1 class="text-3xl font-bold text-westetics-neutral-950 mb-3">
        Link Inválido
      </h1>
      
      <p class="text-westetics-neutral-600 text-lg mb-8">
        O link que você está tentando acessar está incorreto ou foi digitado errado.
      </p>

      <!-- Dicas -->
      <div class="bg-westetics-neutral-100 rounded-xl p-5 mb-8 text-left border border-westetics-neutral-200">
        <p class="text-sm text-westetics-neutral-800 font-semibold mb-3">O que fazer?</p>
        <ul class="text-sm text-westetics-neutral-600 space-y-2">
          <li class="flex items-start gap-3">
            <svg class="w-5 h-5 text-westetics-purple-500 flex-shrink-0 mt-0.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd" />
            </svg>
            <span>Verifique se o link está correto e completo</span>
          </li>
          <li class="flex items-start gap-3">
            <svg class="w-5 h-5 text-westetics-purple-500 flex-shrink-0 mt-0.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd" />
            </svg>
            <span>Copie novamente o link original enviado pela clínica</span>
          </li>
          <li class="flex items-start gap-3">
            <svg class="w-5 h-5 text-westetics-purple-500 flex-shrink-0 mt-0.5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd" />
            </svg>
            <span>Entre em contato com a clínica para confirmar o link</span>
          </li>
        </ul>
      </div>

      <!-- Botão -->
      <button 
        (click)="goHome()"
        class="inline-flex items-center justify-center gap-2 py-3 px-8 rounded-lg font-semibold text-white transition-all duration-200
               bg-westetics-purple-500 hover:bg-westetics-purple-600 
               focus:outline-none focus:ring-2 focus:ring-westetics-purple-500 focus:ring-offset-2"
      >
        <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
        </svg>
        Voltar para o Início
      </button>
    </div>
  </div>

  <!-- Lado Direito - Imagem -->
  <div class="flex-1 relative overflow-hidden">
    <!-- Imagem de fundo -->
    <div 
      class="absolute inset-0 bg-cover bg-center bg-no-repeat"
      style="background-image: url('assets/img/LandingPage-1.png');"
    ></div>
    
    <!-- Conteúdo sobre a imagem -->
    <div class="relative z-10 flex flex-col justify-end items-center p-12 xl:p-16 pb-16 w-full h-full">
      <!-- Logo branco -->
      <img 
        src="assets/icons/Westhetics_White_Full_Logo.svg" 
        alt="Westhetics" 
        class="h-12 w-auto"
      />
    </div>
  </div>
</div>
